/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ConvictionAllocationType = {
    CONVICTION: 'conviction'
} as const;
export type ConvictionAllocationType = typeof ConvictionAllocationType[keyof typeof ConvictionAllocationType];


export function instanceOfConvictionAllocationType(value: any): boolean {
    for (const key in ConvictionAllocationType) {
        if (Object.prototype.hasOwnProperty.call(ConvictionAllocationType, key)) {
            if (ConvictionAllocationType[key as keyof typeof ConvictionAllocationType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ConvictionAllocationTypeFromJSON(json: any): ConvictionAllocationType {
    return ConvictionAllocationTypeFromJSONTyped(json, false);
}

export function ConvictionAllocationTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConvictionAllocationType {
    return json as ConvictionAllocationType;
}

export function ConvictionAllocationTypeToJSON(value?: ConvictionAllocationType | null): any {
    return value as any;
}

export function ConvictionAllocationTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): ConvictionAllocationType {
    return value as ConvictionAllocationType;
}

